import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image, ScrollView, Alert, Platform } from 'react-native';
import { FlashList } from "@shopify/flash-list";
import { LinearGradient } from 'expo-linear-gradient';
import { FontAwesome5, FontAwesome, MaterialCommunityIcons, MaterialIcons, Ionicons } from '@expo/vector-icons';
import * as Linking from 'expo-linking';
import * as WebBrowser from 'expo-web-browser';
import MapView, { Marker } from 'react-native-maps';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import Images from '../../constants/Images';
import { Loader, Button, BackgroundGradient, Tag, PhotosDocumentsAddPreviewGrid, CachedImage } from '../../components';
import * as rtApi from '../../components/Api';
import { getCompanyProjectGalleryImageUrl, getCompanyLogoImageUrl, splitFullName, stripPhoneNumber } from '../../utils/Functions';
import * as Contacts from 'expo-contacts';
import UserState from '../../src/contexts/UserState';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import ProjectPreview from '../../components/Projects/ProjectPreview';
import * as Device from 'expo-device';
import { useLinkTo } from '@react-navigation/native';

const ContractorScreen = ({ navigation, route}) => {
  const [user, setUser] = React.useContext(UserState);

  const [loading, setLoading] = React.useState(false);
  const [showInvite, setShowInvite] = React.useState(false);
  const [company, setCompany] = React.useState({ service_areas: [] });
  const [projects, setProjects] = React.useState([]);
  const [projectGallery, setProjectGallery] = React.useState([]);

  const [isTablet, setIsTablet] = React.useState(false);
  const [isWeb, setIsWeb] = React.useState(Platform.OS === 'web');
  const [isReady, setIsReady] = React.useState(false);

  const addContactIcon = <Ionicons name="md-person-add" size={26} color={Colors.blue2} />;
  const defaultLogo = require('../../assets/img/blank_company_logo.jpg');

  const insets = useSafeAreaInsets();
  const linkTo = useLinkTo();

  React.useEffect(() => {
    console.log('useEffect companyId', route.params.contractorId);
    if (route.params?.contractorId) {
      getCompany(route.params.contractorId);
    }
    return () => rtApi.cancel();
  }, [route.params.contractorId]);

  React.useEffect(() => {
    (async () => {
      const deviceType = await Device.getDeviceTypeAsync();
      console.log('deviceType: ', deviceType);
      setIsTablet(deviceType === Device.DeviceType.TABLET ? true : false);
      setIsReady(true);
    })()
  }, []);

  const getCompany = (companyId) => {
    setLoading(true)
    rtApi.get(`companies/${companyId}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); }
      console.log('getContractors', data);
      setLoading(false);
      processCompany(data.company, companyId);
      setProjects(data.agreements);
    })
    .catch((error) => {
      setLoading(false);
      console.log(error);
    });
  }

  const processCompany = (company, id) => {
    console.log('process company: ', company);
    company.id = id;
    setCompany(company);
    let pg = company.project_gallery.map(p => { return { existing: true, path: getCompanyProjectGalleryImageUrl(route.params.contractorId, p), type: 'image' } });
    setProjectGallery(pg);
    setShowInvite(company.invite);
  }

  // invite
  const inviteContractor = () => {
    const link = `/contractor/${route.params.contractorId}/invite?inviteType=Contractor&name=${company.full_name}&email=${company.email_address}&phone=${company.phone_number}&contractorId=${route.params.contractorId}&companyname=${company.name}&role=homeowner`;
    console.log('linkingTo: ', link)
    // linkTo(`/contractor/${company.id}/invite?inviteType=Contractor&name=${company.full_name}&email=${company.email_address}&phone=${company.phone_number}&contractorId=${company.id}`);
    linkTo(link);
    // navigation.navigate('InviteScreen', {
    //   inviteType: 'Contractor',
    //   id: company.id,
    //   name: company.full_name,
    //   email: company.email_address,
    //   phone: company.phone_number,
    // })
  }

  //contact
  const checkAddToContacts = () => {
    // alert('Add ??');
    (async () => {
      const result = await Contacts.getPermissionsAsync();
      console.log('result', result);
      if(result.status === 'granted'){
        //add
        addToContacts();
      }else if(result.status === 'undetermined'){
        //ask
        (async () => {
          const { status } = await Contacts.requestPermissionsAsync();
          if (status === 'granted') {
            addToContacts();
          }
        })();
      }else if(result.status === 'denied'){
        if(result.canAskAgain){
          (async () => {
            const { status } = await Contacts.requestPermissionsAsync();
            if (status === 'granted') {
              addToContacts();
            }
          })();
        }else{
          Alert.alert(
            'Permission Denied',
            'You have perviously denied access to your contacts. Please allow access if you would like to add this contact.',
            [
              {
                text: 'Allow Access',
                onPress: () => { Linking.openURL('app-settings:') },
              },
              {
                text: 'Dont Allow',
              }
            ]
          );
        }
      }
    })();
  }
  const addToContacts = () => {
    let contactId = null;
    (async () => {
      // setLoading(true); //set to false when alerted after add/update
      const { data } = await Contacts.getContactsAsync();
      if (data.length > 0) {
        for(let i=0;i<data.length;i++){
          let contact = data[i];
          if (isContactAMatch(contact, company)){
            console.log('isMatch', contact);
            contactId = contact.id;
            break;
          }else{
            console.log('isNotMatch', contact);
          }
        }
        if(contactId){
          updateContact(contactId);
        }else{
          addNewContact();
        }
        // data.forEach((contact) => {
        //   console.log(contact);
        // })
      }else{
        addNewContact();
      }
    })();
    
  }
  const isContactAMatch = (contact, contractor) => {
    if(
      contact.contactType === 'company'
      && (contact.firstName + ' ' + contact.lastName) === contractor.full_name
      && contact.company === contractor.name
    ){ return true; }
    return false;
  }
  const addNewContact = () => {
    (async () => {
      const contact = contactFromContractor();
      console.log('addNewContact: ', contact);
      const contactId = await Contacts.addContactAsync(contact);
      if (contactId) {
        await Contacts.presentFormAsync(contactId, contact, { cancelButtonTitle: 'Save' });
      }
      // setLoading(false);
      // alertContactEdit('add');
      console.log('added new contact', contact, contactId);
    })();
  }
  const updateContact = (contactId) => {
    (async () => {
      const contact = contactFromContractor(contactId);
      await Contacts.updateContactAsync(contact);
      if (contactId) {
        await Contacts.presentFormAsync(contactId, contact, { cancelButtonTitle: 'Save' });
      }
      // alertContactEdit('update');
      // setLoading(false);
      console.log('updated existing contact', contact, contactId);
    })();
  }
  const contactFromContractor = (contactId) => {
    // const contact = {
    //   [Contacts.Fields.FirstName]: company.firstName,
    //   [Contacts.Fields.LastName]: route.params.contractor.lastName,
    //   [Contacts.Fields.ContactType]: 'company',
    //   [Contacts.Fields.Company]: route.params.contractor.contractorName,
    //   phoneNumbers: [{
    //     number: route.params.contractor.phoneNumber,
    //     isPrimary: true,
    //     digits: route.params.contractor.phoneNumber.replace(/\D/g, ''),

    //   }],
    //   urlAddresses: [{
    //     url: route.params.contractor.website,
    //     label: 'Website',
    //   }],
    // }
    let contact = {};
    contact[Contacts.Fields.ContactType] = Contacts.ContactTypes.Company;
    contact[Contacts.Fields.Company] = company.name;
    let names = splitFullName(company.full_name);
    contact[Contacts.Fields.FirstName] = names[0];
    contact[Contacts.Fields.LastName] = names[1];
    contact[Contacts.Fields.Emails] = [
      // {
      //   email: company.email_address,
      //   isPrimary: false,
      //   label: 'Contractor Email Address'
      // },
      {
        email: company.email_address,
        isPrimary: false,
        label: 'Company Email Address'
      },
    ];
    contact[Contacts.Fields.PhoneNumbers] = [
      // {
      //   number: homeownerContractor.phone_number,
      //   isPrimary: false,
      //   digits: stripPhoneNumber(homeownerContractor.phone_number),
      //   label: 'Contractor Phone Number'
      // },
      {
        number: company.phone_number,
        isPrimary: false,
        digits: stripPhoneNumber(company.phone_number),
        label: 'Company Phone Number'
      },
    ];
    contact[Contacts.Fields.Addresses] = [{
      street: company.street,
      city: company.city,
      country: company.country,
      region: company.state,
      postalCode: company.zip_code,
      label: 'Company Address',
    }];
    contact[Contacts.Fields.UrlAddresses] = [{
      url: company.website,
      label: 'Company Website',
    }]
    if(contactId){
      contact.id = contactId;
    }
    // if (company.logo) {
    //   contact[Contacts.Fields.ImageAvailable] = true;
    //   contact[Contacts.Fields.RawImage] = { uri: getCompanyLogoImageUrl(company.id, company.logo), width: Images.company.logo.width, height: Images.company.logo.height };
    //   // contact[Contacts.Fields.Image] = { uri: getCompanyLogoImageUrl(company.id, company.logo), width: Images.company.logo.width, height: Images.company.logo.height };
    // }
    return contact;
  }
  const alertContactEdit = (action) => {
    const message = 'Successfully '+((action === 'add') ? 'added' : 'updated')+' contact';
    Alert.alert('Success', message, [{text: 'OK', onPress: ()=>{ setLoading(false); }}]);
  }

  // call
  const phoneCall = (phoneNumber) => {
    Linking.openURL('tel:'+phoneNumber);
  }

  // website
  const openWebsite = async (url) => {
    if(!(url.includes('http://') && url.includes(url))){
      url = 'http://' + url;
    }
    if(Platform.OS === 'web'){
      window.open(url, '_blank');
    }else{
      WebBrowser.openBrowserAsync(url);
    }
  }
  const openAddress = () => {
    const address = encodeURIComponent(company.address);
    openMapAddress(address);
  }
  const openServiceArea = (addr) => {
    const address = encodeURIComponent(`${addr.city} ${addr.state}`);
    openMapAddress(address);
  }
  const openMapAddress = (address) => {
    if (Platform.OS === 'web') {
      window.open(`https://maps.google.com/maps?daddr=${address}`, '_blank');
    } else {
      const appleGoogle = Platform.OS === "ios" ? "apple" : "google";
      Linking.openURL(`http://maps.${appleGoogle}.com/maps?daddr=${address}`);
    }
  }

  // const onRegionChange = (region) => {
  //   console.log('onRegionChange', region);
  //   setRegion( region );
  // }

  const imgStyle = () => {
    if(Platform.OS === 'web'){
      return {
        width: 768,
        height: 768 * (Images.company.logo.height / Images.company.logo.width),
      }
    }
    return { aspectRatio: Images.company.logo.width / Images.company.logo.height }
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo('/contractors');
    }
  }

  return (
    <ScrollView keyboardShouldPersistTaps='handled' style={styles.scrollView}>
      {/* <StatusBar backgroundColor={Colors.yellow} /> */}
      <BackgroundGradient />
      <Loader animating={loading} />
      <View style={styles.logoContainer}>
        {!company.logo &&
          <Image source={defaultLogo} style={[CS.responsiveImage, styles.logo, imgStyle()]} />
        }
        {company.logo &&
          <CachedImage source={{ uri: getCompanyLogoImageUrl(company.id, company.logo) }} style={[CS.responsiveImage, styles.logo, imgStyle()]} />
        }
        <LinearGradient colors={[Colors.darkGrey, 'transparent', Colors.darkGrey]} style={styles.gradient} />
        <View style={[styles.buttonsOverlay, { top: insets.top ? insets.top : 10 }]}>
          <TouchableOpacity onPress={goBack}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </TouchableOpacity>
          {/* <TouchableOpacity onPress={editContractor} style={styles.editButton}>
            <Entypo name="edit" size={24} color="white" />
          </TouchableOpacity> */}
        </View>
        <View style={styles.companyInfoOverlay}>
          <Text style={styles.contractorName}>{company.name}</Text>
          <Text style={[CS.smallText, CS.lightText, CS.boldText, styles.contactName]}>{company.full_name}</Text>
        </View>
      </View>
      <View style={[CS.innerContainer, styles.container]}>
        {showInvite &&
          <View style={{ marginVertical: 10 }}>
            <Button text='Invite to My Project' onPress={() => inviteContractor} />
          </View>
        }
        {/* bio */}
        {company.bio !== '' ?
          <View style={styles.section}>
            <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 10 }]}>Bio</Text>
            <Text style={[CS.smallText, CS.lightText]}>{company.bio}</Text>
          </View>
        : null}
        {/* gallery */}
        {projectGallery.length > 0 &&
          <View style={styles.section}>
            <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 10 }]}>Project Gallery</Text>
            <PhotosDocumentsAddPreviewGrid
              items={projectGallery}
              showAdd={false}
            />
          </View>
        }
        {/* contact */}
        <View style={styles.section}>
          <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 10 }]}>Contact</Text>
          {/* {addContactIcon} */}
          {Platform.OS !== 'web'
          ?
            <View style={{ marginVertical: 5 }}>
              <Button text='Add to Contacts' onPress={() => checkAddToContacts} color='blue' icon={addContactIcon} />
            </View>
          : null
          }
          {company.phone_number !== '' ?
            <View style={[CS.rowContainer, styles.contactRow]}>
              <View style={styles.contactIcon}>
                <FontAwesome name="phone" size={24} color={Colors.lightBlue2} />
              </View>
              <TouchableOpacity onPress={() => phoneCall(company.phone_number)}>
                <Text style={styles.contactText}>{company.phone_number}</Text>
              </TouchableOpacity>
            </View>
          : null}
          {company.website !== '' ?
            <View style={[CS.rowContainer, styles.contactRow]}>
              <View style={styles.contactIcon}>
                <MaterialCommunityIcons name="web" size={24} color={Colors.lightBlue2} />
              </View>
              <TouchableOpacity onPress={() => openWebsite(company.website)}>
                <Text style={styles.contactText}>{company.website}</Text>
              </TouchableOpacity>
            </View>
          : null}
          {company.address !== '' ?
            <TouchableOpacity activeOpacity={0.6} onPress={openAddress} style={[CS.rowContainer, styles.contactRow]}>
              <View style={styles.contactIcon}>
                <MaterialIcons name="location-on" size={24} color={Colors.lightBlue2} />
              </View>
              <Text style={styles.contactText}>{company.address}</Text>
            </TouchableOpacity>
          : null}
          {/* 43.679853, -79.669913 */}
          {(company.latitude && company.longitude) &&
            (Platform.OS !== 'web' ?
            <MapView onPress={openAddress} style={styles.map} region={{ latitude: company.latitude, longitude: company.longitude, latitudeDelta: 0.02, longitudeDelta: 0.02 }} zoomEnabled={false} scrollEnabled={false}>
              <Marker coordinate={{ latitude: company.latitude, longitude: company.longitude }} title={company.name} description={company.address} />
            </MapView>
            : null)
          }
          {(company.latitude && company.longitude) &&
            (Platform.OS === 'web' ?
            <MapView onPress={openAddress} style={styles.webMap} region={{ latitude: company.latitude, longitude: company.longitude, latitudeDelta: 0.02, longitudeDelta: 0.02 }} zoomEnabled={false} scrollEnabled={false}>
              <MapView.Marker coordinate={{ latitude: company.latitude, longitude: company.longitude }} title={company.name} description={company.address} />
            </MapView>
              : null)
          }
        </View>
        {/* service areas */}
        {company.service_areas.length > 0 &&
          <View style={styles.section}>
            <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 10 }]}>Service Areas</Text>
            <View style={styles.tags}>
              {company.service_areas.map((s, i) =>
                <TouchableOpacity activeOpacity={0.6} onPress={() => openServiceArea(s)} key={i}>
                  <Tag text={s.city + ', ' + s.state} key={s.id} />
                </TouchableOpacity>
              )}
            </View>
          </View>
        }
        {/* skills */}
        {/* <View style={styles.section}>
          <Text style={[CS.smallTitle, CS.lightText]}>Skills</Text>
          <View style={styles.tags}>
            {route.params.contractor.skills.map((s) =>
              <Tag text={s} key={s} />
            )}
          </View>
        </View> */}
        {/* projects */}
        {/* <Text style={[CS.smallTitle, CS.lightText]}>Projects</Text> */}
        {isReady && projects.length >= 1 &&
          <View style={{ marginBottom: 10 }}>
            <FlashList
              data={projects}
              renderItem={({ item }) => <ProjectPreview project={item} showCompleted={true} />}
              ItemSeparatorComponent={() => (<View style={{ height: 10 }} />)}
              keyExtractor={item => item.id.toString()}
              ListHeaderComponent={() => (<Text style={[CS.smallTitle, CS.lightText]}>Projects</Text>)}
              // refreshControl={<RefreshControl refreshing={loading} onRefresh={() => getProjects(selectedAddress)} colors={[Colors.yellow]} tintColor={Colors.yellow} />}
              // ListEmptyComponent={() => <Text style={[CS.smallText, CS.lightBlueText, CS.centerText]}>You have no projects in progress at the moment. Click the <Ionicons name="ios-add-circle" size={18} color={Colors.yellow} /> icon to start one.</Text>}
              numColumns={(isTablet || isWeb) ? 2 : 1}
              // numColumns={2}
              horizontal={false}
              columnWrapperStyle={(isTablet || isWeb) && { flex: 1, justifyContent: 'flex-start' }}
              estimatedItemSize={183}
            />
          </View>
        }
        
        {/* {projects.map(p => {
          return (
            <View style={{ marginBottom: 10 }} key={p.id}>
              <ProjectPreview project={p} showCompleted={true} />
            </View>
          )
        })} */}
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  logoContainer: {
    // flex: 1,
    width: '100%',
    maxWidth: Platform.OS === 'web' ? 768 : 'auto',
    alignSelf: 'center',
    backgroundColor: 'pink',
  },
  scrollView: {
    backgroundColor: Colors.blue,
  },
  logo: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  gradient: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: '100%',
  },
  buttonsOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    paddingHorizontal: 15,
    flexDirection: 'row',
    alignItems: 'center',
    // backgroundColor: 'red',
  },
  editButton: {
    marginLeft: 'auto',
    // marginRight: 15,
  },
  companyInfoOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width:'100%',
    padding:15,
  },
  contractorName: {
    marginBottom:5,
    fontSize: 24,
    ...Platform.select({
      ios: {
        fontWeight: '900',
      },
      web: {
        fontWeight: '900',
      },
      android: {
        fontWeight: 'bold',
      }
    }),
    color: Colors.yellow,
  },
  section: {
    marginBottom: 20,
  },
  contactRow: {
    marginTop:10,
  },
  contactIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
  },
  contactText: {
    fontSize:20,
    fontWeight: 'bold',
    color: Colors.lightBlue2,
    marginLeft:10,
    flex: 1,
  },
  map: {
    width:'100%',
    height:200,
    marginTop:10,
    borderRadius: 15
  },
  webMap: {
    width: '100%',
    height: 400,
    marginTop: 10,
    borderRadius: 15
  },
  tags: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  thumbContainer: {
    borderRadius: 5,
    flex: 1,
    flexBasis: '23.5%',
    flexGrow: 0,
    marginRight:'2%',
    marginBottom:'2%',
  },
  thumbContainerNoRightMargin: {
    borderRadius: 5,
    flex: 1,
    flexBasis: '23.5%',
    flexGrow: 0,
    marginRight: 0,
    marginBottom: '2%',
  },
  thumb: {
    aspectRatio: 150 / 150,
    borderRadius: 5,
  },
})

export default ContractorScreen;